'use strict';

exports.__esModule = true;
exports.default = objectHash;

var _util = require('./util');

// Stable json stringify that the keys are sorted
function objectHash(data) {
  if ((0, _util.isPlainObject)(data)) {
    var keys = Object.keys(data).sort();
    var rv = '{';
    for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var key = _ref;

      var value = objectHash(data[key]);
      if (!(0, _util.isUndefined)(value)) {
        rv += JSON.stringify(key) + ':' + value + ',';
      }
    }
    rv = rv.slice(0, rv.length - 1);
    rv += '}';
    return rv;
  }
  if (Array.isArray(data)) {
    var _rv = '[';
    for (var _iterator2 = data, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var entry = _ref2;

      _rv += objectHash(entry);
      _rv += ',';
    }
    _rv = _rv.slice(0, _rv.length - 1);
    _rv += ']';
    return _rv;
  }
  if (typeof data === 'number' || (0, _util.isUndefined)(data)) {
    return data;
  }
  return JSON.stringify(data);
}


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/objectHash.js
// module id = 228
// module chunks = 15